import { createTheme } from "@mui/material/styles";
import { styled, alpha } from "@mui/material/styles";
export const light_theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  shape: {
    borderRadius: 8, // Увеличиваем скругление
  },
  palette: {
    mode: "light",
    common: {
      black: "#000",
      white: "#fff",
    },

    primary: {
      main: "#fff",
      light: "#fff",
      dark: "#000",
    },
    secondary: {
      main: "#fff",
      light: "#42a5f5",
      dark: "#1565c0",
    },
    text: {
      primary: "#000", // Средний серый
      secondary: "#2D3748", // Тёмно-серый (заменяет значение по умолчанию near-black)
      disabled: "#A0AEC0", // Светло-серый
      hint: "#A0AEC0", // Совпадает с disabled для консистентности
      banner: "#2D3748",
      dark: "#000",
    },
  },

  color: {
    main: "#fff",
    secondary: "#2B2B2B",
    third: "#D7D7D7",
    card: "#F5F5F5",
    body: "#F5F5F5",
    hint: "#A0AEC0", // Совпадает с disabled для консистентности
    input: "#F5F5F5", // Светло-серый
    input_hover: "#D7D7D7", // Светло-серый
    banner: "#F5F5F5",
    button: "#C8C5C5",
    gradient1: "#fff",
    gradient2: alpha("#2912f0", 0.3),
    gradient3: alpha("#f30a0a", 0.3),
  },
});

export default light_theme;
